import * as ActionTypes from '../ActionTypes'
import * as RestURI from '../../shared/RestURI';
import {awsConfig} from '../../shared/config';

import {addToBucket} from './ActionCreatorsBucket';
import * as AuthC from '../../utils/auth/AuthCognito';
import {getAuthorizedWorksitesForContextClient, getAuthorizedWorksitesForEmployer} from '../../utils/auth/Security';
import * as RestCallHelper from '../../utils/network/RestCallHelper';
import * as AFStateHelper from '../../components/AFStateHelper';


const employerWorksitesLoading = (loadCriteria) => ({
    type: ActionTypes.EMPLOYER_WORKSITES_LOADING,
    payload: loadCriteria
});

const employerWorksitesFailed = (errmess) => ({
    type: ActionTypes.EMPLOYER_WORKSITES_FAILED,
    payload: errmess
});

const addEmployerWorksites = (worksites) => ({
    type: ActionTypes.ADD_EMPLOYER_WORKSITES,
    payload: worksites
});

const addEmployerWorksite = (worksite) => ({
    type: ActionTypes.ADD_EMPLOYER_WORKSITE,
    payload: worksite
});


const updateEmployerWorksite = (worksite) => ({
    type: ActionTypes.UPDATE_EMPLOYER_WORKSITE,
    payload: worksite
});


export const fetchWorksitesForEmployer = (employerId) => (dispatch) => {

    var urlParams = new URLSearchParams({ employerId: employerId });
    var authzWorksites = getAuthorizedWorksitesForEmployer(employerId);

    if(authzWorksites) {
        urlParams.append("wslist", authzWorksites);
    }

    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.WORKSITES}?${urlParams}`);

    const contextClientId = AFStateHelper.getContextClientId();
    dispatch(employerWorksitesLoading({employerId: employerId, eClientId: contextClientId}));
 
    RestCallHelper.fetchAsJson(url)
        .then(worksites => dispatch(addEmployerWorksites(worksites)))
        .catch(error => {
            dispatch(employerWorksitesFailed(error.message))
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul citirii Punctelor de Lucru" } }));
        });
}


export const fetchWorksitesForClient = (clientId) => (dispatch) => {

    var urlParams = new URLSearchParams({ clientId: clientId });
    var authzWorksites = getAuthorizedWorksitesForContextClient();

    if(authzWorksites) {
        urlParams.append("wslist", authzWorksites);
    }

    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.WORKSITES}?${urlParams}`);

    dispatch(employerWorksitesLoading({clientId: clientId}));
 
    RestCallHelper.fetchAsJson(url)
        .then(worksites => dispatch(addEmployerWorksites(worksites)))
        .catch(error => {
            dispatch(employerWorksitesFailed(error.message))
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul citirii Punctelor de Lucru" } }));
        });
}


export const postEmployerWorksite = (worksite) => (dispatch) => {
    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(awsConfig.api.invokeUrl + RestURI.WORKSITES, {
        method: "POST",
        body: JSON.stringify(worksite),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                throw error;
            }
        )
        .then(response => response.json())
        .then(worksite => dispatch(addEmployerWorksite(worksite)))
        .then(wsAction => dispatch(addToBucket({ mostRecentWsId: wsAction.payload.id, snackbar: { open: true, severity: "success", message: "Datele Punctului de Lucru au fost adaugate cu succes" } })))
        .catch(error => {
            dispatch(employerWorksitesFailed(error.message))
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul crearii Punct de Lucru" } }));
        });
}


export const patchEmployerWorksite = (worksite) => (dispatch) => {
    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(awsConfig.api.invokeUrl + RestURI.WORKSITES + `/${worksite.id}`, {
        method: "PATCH",
        body: JSON.stringify(worksite),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                throw error;
            }
        )
        .then(response => response.json())
        .then(worksite => dispatch(updateEmployerWorksite(worksite)))
        .then(wsAction => dispatch(addToBucket({ snackbar: { open: true, severity: "success", message: "Datele Punctului de Lucru actualizate cu succes" } })))
        .catch(error => {
            dispatch(employerWorksitesFailed(error.message));
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul actualizarii Punctului de Lucru" } }));
        });
}
